<template>
  <div class="dropdown-parent-container">
    <button
      type="button"
      class="dropdown-menu-toggle-arrow-icon-button sc3-button sc3-button-grey sc3-button-control-bar-lower-size"
      :class="{ 'dropdown-menu-toggle-arrow-icon-button-open sc3-button-active': isOpen }"
      ref="shareDropdownMenuToggleButtonNode"
      @click="toggleDropdown()"
    >
      <i class="fas fa-fw fa-share"></i>
      &nbsp;Share
      &nbsp;
      <i class="fas fa-angle-down"></i>
    </button>
    <DropdownMenu
      :nodes-excluded-from-closing-on-outside-click="shareDropdownMenuToggleButtonNode ? [shareDropdownMenuToggleButtonNode] : []"
      :dropdown-button-left-value="left"
      v-model:is-open="isOpen"
      v-model:max-body-height="dropdownHeight"
      :dropdown-menu-toggle-button-node="shareDropdownMenuToggleButtonNode"
    >
      <template v-slot:body>
        <ul>
          <li>
            <button type="button" @click="[closeDropdown(), launchComingSoonModal()]">
              <i class="fab fa-fw fa-twitter-square twitter-button-icon"></i>
              &nbsp;Twitter
            </button>
          </li>
          <li>
            <button type="button" @click="[closeDropdown(), launchComingSoonModal()]">
              <i class="fab fa-fw fa-facebook-square facebook-button-icon"></i>
              &nbsp;Facebook
            </button>
          </li>
          <li>
            <button type="button" @click="[closeDropdown(), launchComingSoonModal()]">
              <i class="fab fa-fw fa-linkedin linkedin-button-icon"></i>
              &nbsp;LinkedIn
            </button>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <button type="button" @click="[closeDropdown(), launchEmailModal()]">
              <i class="fas fa-fw fa-at"></i>
              &nbsp;Email Chart
            </button>
          </li>
        </ul>
      </template>
    </DropdownMenu>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { useBoundingClientRect } from '@/composables/useBoundingClientRect';
  import { useModals } from '@/composables/useModals';
  import DropdownMenu from '@/components/dropdowns/DropdownMenu.vue';

  const { getBoundingClientRectPropertyRefs } = useBoundingClientRect();
  const {
    launchEmailModal,
    launchComingSoonModal
  } = useModals();
  const shareDropdownMenuToggleButtonNode = ref<HTMLButtonElement>();
  const isOpen = ref<boolean>(false);
  const dropdownHeight = ref<number>(0);
  const { left } = getBoundingClientRectPropertyRefs(shareDropdownMenuToggleButtonNode, { windowResize: true });

  function toggleDropdown() {
    isOpen.value = !isOpen.value;
  }

  function closeDropdown() {
    isOpen.value = false;
  }

  watch(isOpen, () => {
    if (!isOpen.value) {
      shareDropdownMenuToggleButtonNode.value?.blur();
    }
  });
</script>

<style scoped>
  .dropdown-parent-container {
    position: relative;
  }

  ul {
    max-height: v-bind('`${dropdownHeight}px`');
  }
</style>
